import { apiService } from "../apiServices";
import config from "../../../config/domain";
import servicesList from "../serviceList";

/**
 * Dion Post Data API
 */
export const ADionPostData = (callback: CallableFunction, dionObj: any) => {
  apiService(
    {
      url: "Dion/PostData",
      body: {
        accountCategory: dionObj?.accountCategory,
        applicationId: dionObj?.applicationId,
        stage: dionObj?.stage,
        userId: dionObj?.userId,
      },
      method: "POST",
      apiBaseUrl: config.diyNewApiUrl,
      tempToken: config.tempToken,
      serviceName: servicesList.getStageCompletionStatus,
    },
    callback
  );
};

/**
 * E-Log Get Auth URL API
 */
export const AElogGetAuthUrl = (callback: CallableFunction, clientCode: any) => {
  apiService(
    {
      url: "Elog/GetAuthUrl",
      body: {
        clientCode: clientCode,
      },
      method: "POST",
      apiBaseUrl: config.diyNewApiUrl,
      tempToken: config.tempToken,
      serviceName: servicesList.getStageCompletionStatus,
    },
    callback
  );
};

/**
 * E-Log Update Status API
 */
export const AElogUpdateStatus = (callback: CallableFunction, elogObj: any) => {
  apiService(
    {
      url: "Elog/UpdateStatus",
      body: {
        applicationId: elogObj?.applicationId,
        isElogOpted: elogObj?.isElogOpted ?? false,
        status: elogObj?.status,
        statusCode: elogObj?.statusCode,
        isElogApiResponse: elogObj?.isElogApiResponse,
      },
      method: "POST",
      apiBaseUrl: config.diyNewApiUrl,
      tempToken: config.tempToken,
      serviceName: servicesList.getStageCompletionStatus,
    },
    callback
  );
};
